import { useNavigate } from "react-router-dom";

const STYLE = {
  none: ["bg-slate-300", "text-slate-500", "bg-slate-100"],
  completed: ["bg-emerald-500", "text-emerald-800", "bg-emerald-100"],
  in_progress: ["bg-blue-500", "text-blue-800", "bg-blue-100"],
  not_started: ["bg-slate-300", "text-slate-600", "bg-slate-100"],
};

// Same calculation everywhere (server-computed checklist_stats: completed ÷ applicable); click opens the project's Checklist & Team tab.
export const ChecklistProgress = ({ project: p, compact = false }) => {
  const navigate = useNavigate();
  const s = p.checklist_stats || { total: 0, completed: 0, percent: 0, state: "none", label: "No checklist" };
  const [bar, text, badge] = STYLE[s.state] || STYLE.none;
  if (!s.total) {
    return (
      <div className="flex items-center gap-2 text-[11px] text-slate-500" data-testid={`checklist-progress-${p.project_code}`}>
        <span data-testid={`checklist-state-${p.project_code}`}>No checklist</span>
        <button type="button" onClick={(e) => { e.stopPropagation(); navigate(`/projects/${p.id}?tab=checklist`); }} className="text-teal-700 hover:underline" data-testid={`add-checklist-${p.project_code}`}>Add checklist</button>
      </div>
    );
  }
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); navigate(`/projects/${p.id}?tab=checklist`); }} className="block w-full min-w-[150px] text-left group" title="Open Checklist & Team" data-testid={`checklist-progress-${p.project_code}`}>
      <div className="flex items-center gap-2">
        <div className="h-2 flex-1 rounded-full bg-slate-200 overflow-hidden"><div className={`h-full ${bar} transition-[width]`} style={{ width: `${s.percent}%` }} /></div>
        <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded whitespace-nowrap ${badge} ${text}`} data-testid={`checklist-state-${p.project_code}`}>{s.label}</span>
      </div>
      {!compact && <div className="text-[11px] text-slate-500 mt-0.5 group-hover:text-slate-700 whitespace-nowrap">{`${s.completed} of ${s.total} complete · ${s.percent}%`}</div>}
    </button>
  );
};
